/**
 * Official OnlyOneTap social media profiles.
 * Used by the desktop footer and the Organization JSON-LD (sameAs).
 */
export const FACEBOOK_URL = "https://www.facebook.com/people/Onlyonetap/61591752694620/";
export const INSTAGRAM_URL = "https://www.instagram.com/onlyonetapindia/";
